import React, { useRef } from 'react';
import { Label } from '@/shared/ui/label';

interface GpsFileUploadProps {
  selectedFile: File | null;
  onChange: (file: File | null) => void;
  disabled?: boolean;
}

export const GpsFileUpload: React.FC<GpsFileUploadProps> = ({ selectedFile, onChange, disabled }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const selectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    if (file && !file.name.toLowerCase().endsWith('.gpx')) {
      window.alert('Please select a GPX file exported with the drone video.');
      event.target.value = '';
      onChange(null);
      return;
    }
    onChange(file);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="gps-file">Flight path GPS (GPX file)</Label>
      <div className="flex items-center gap-3">
        <input
          ref={inputRef}
          id="gps-file"
          type="file"
          accept=".gpx,application/gpx+xml"
          disabled={disabled}
          onChange={selectFile}
          className="block w-full text-sm text-muted-foreground file:mr-4 file:rounded-md file:border-0 file:bg-primary/10 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-primary hover:file:bg-primary/15"
        />
        {selectedFile && (
          <button type="button" onClick={() => { if (inputRef.current) inputRef.current.value = ''; onChange(null); }} className="text-sm text-destructive" disabled={disabled}>
            Clear
          </button>
        )}
      </div>
      <p className="text-sm text-muted-foreground">
        Optional. Upload the GPX exported for this exact recording to enable the synchronized flight path.
      </p>
    </div>
  );
};
